'use strict';

// Disabled until we stop loading jQuery globally
// import $ from 'jQuery';

$('.o-form__togglable-select').on('change', '.o-input__checkbox > input', function () {
   const select = $(this).closest('.o-form__togglable-select').find('.o-custom-select select');

   // Reverse the default disabled
   select.prop('disabled', !select.prop('disabled'));
});



// WEBPACK FOOTER //
// ./src/js/components/toggleable-select.js